import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { features } from '@kdcloudjs/table';
function useRowSelection(pipeline, rowSelection) {
  if (rowSelection) {
    if (rowSelection.type === 'radio') {
      var column = rowSelection.column,
        fixed = rowSelection.fixed,
        _onChange = rowSelection.onChange,
        value = rowSelection.value,
        defaultValue = rowSelection.defaultValue,
        clickArea = rowSelection.clickArea,
        other = __rest(rowSelection, ["column", "fixed", "onChange", "value", "defaultValue", "clickArea"]);
      pipeline.use(features.singleSelect(_extends({
        defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue[0],
        value: value ? value.length === 0 ? '' : value[0] : undefined,
        radioColumn: column,
        radioPlacement: fixed,
        onChange: function onChange(next) {
          return _onChange === null || _onChange === void 0 ? void 0 : _onChange([next]);
        },
        clickArea: clickArea === 'self' ? 'radio' : clickArea
      }, other)));
    } else {
      var _column = rowSelection.column,
        _fixed = rowSelection.fixed,
        _onChange2 = rowSelection.onChange,
        _clickArea = rowSelection.clickArea,
        _other = __rest(rowSelection, ["column", "fixed", "onChange", "clickArea"]);
      pipeline.use(features.multiSelect(_extends({
        checkboxColumn: _column,
        checkboxPlacement: _fixed,
        onChange: function onChange(next, key, keys, action) {
          return _onChange2 === null || _onChange2 === void 0 ? void 0 : _onChange2(next, key, keys, action);
        },
        clickArea: _clickArea === 'self' ? 'checkbox' : _clickArea
      }, _other)));
    }
  }
}
export default useRowSelection;